import { Badge, IconButton } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { Notifications } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { AppContext } from '../contexts/AppContext';
import { LoginContext } from '../contexts/LoginContext';
import notificationsAPI from '../services/NotificationsApi';
import { DRAWER_WIDTH } from '../theme/CustomThemeProvider';
import useRoutingUtils from '../utils/RoutingUtils';
import NotificationModal from './NotificationModal';

const useStyles = makeStyles(theme => ({
  appBar: {
    backgroundColor: 'white',
    color: '#888',
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  show: {
    marginRight: 36,
    transition: theme.transitions.create(['margin', 'visibility'], {
      easing: theme.transitions.easing.easyIn,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  hide: {
    visibility: 'hidden',
    marginRight: -36,
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

const HeaderBar = ({ openDrawer, setOpenDrawer }) => {
  const classes = useStyles();

  const { isSupplier } = useContext(LoginContext);
  const { goHome } = useRoutingUtils();

  const [notifications, setNotifications] = useState([]);
  const { showError } = useContext(AppContext);
  const [open, setOpen] = useState(false);

  const getNotifications = () => {
    notificationsAPI
      .getSupplierNotifications()
      .then(res => {
        const unreadNotifications = res.filter(notification => !notification.read);
        setNotifications(res);
        setOpen(isSupplier && !unreadNotifications.isEmpty());
      })
      .catch(error => showError('Error al buscar notificaciones'));
  };

  useEffect(() => {
    isSupplier && getNotifications();
  }, []);

  return (
    <Fragment>
      <NotificationModal open={open} setOpen={setOpen} notifications={notifications} setNotifications={setNotifications} />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openDrawer,
        })}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpenDrawer(true)}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: openDrawer,
              [classes.show]: !openDrawer,
            })}>
            <MenuIcon />
          </IconButton>
          <div className={classes.header}>
            <img src={process.env.PUBLIC_URL + '/logo_acerbrag.png'} alt="AcerBrag" style={{ cursor: 'pointer' }} onClick={goHome} />
            {isSupplier && (
              <IconButton color="default" aria-label="notifications" onClick={() => setOpen(true)}>
                <Badge badgeContent={notifications.filter(notif => !notif.read).length} color="secondary">
                  <Notifications />
                </Badge>
              </IconButton>
            )}
          </div>
        </Toolbar>
      </AppBar>
    </Fragment>
  );
};

export default HeaderBar;
